import firebase from 'firebase/compat/app';
import STORE_CONSTANTS, {
  BONUS_APPS_DOC,
  BONUS_APPS_VERSION,
} from '../constants';
import withoutNulls from '../../api/search/withoutNulls';

export { BONUS_APPS_DOC, BONUS_APPS_VERSION };

const bonusAppConverter = {
  toFirestore(app: V3.BonusApp): firebase.firestore.DocumentData {
    return withoutNulls({ ...app });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<V3.BonusApp>,
    options: firebase.firestore.SnapshotOptions,
  ): V3.BonusApp {
    const data = {
      ...snapshot.data(options),
    };

    const app: V3.BonusApp = {
      ...data,
      appViewersAccess: data.appViewersAccess
        ? data.appViewersAccess
        : {
            isPublic: false,
            userIds: [],
            groupIds: [],
          },
      adminUserIds: data.adminUserIds ? data.adminUserIds : [],
    };

    return app;
  },
};

const getBonusAppsRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.CONTENT_DISTRIBUTIONS_COLLECTION)
    .doc(BONUS_APPS_DOC)
    .collection(BONUS_APPS_VERSION)
    .withConverter(bonusAppConverter);
};

export default getBonusAppsRef;
